import React from 'react';
import { Row, Col, Badge } from 'reactstrap';
import { Icon } from '../../../../components/Component';
import { Link } from 'react-router-dom';
import { currencyFormatter } from '../../../explorer/utils';
import { DealCategory, formatDate } from '../../../../utils/envConfig';

const DealRow = ({ deal, className }) => {
  const isSecondaryMarket = deal.category === DealCategory.SecondaryProperty;

  return (
    <Row className={`${className}`}>
      <Col xs={8}>
        <Link to={`/deal-details/${deal.id ?? deal._id}`} target="_blank" rel="noopener noreferrer">
          {deal.reference_number}
          <Icon name={'external'} className="ms-1" />
        </Link>
        <span className="ms-4">
          <Badge pill color={'secondary'} className='px-2 py-1'>
            {deal.category}
          </Badge>
          {isSecondaryMarket ? (
            <Badge pill color={'primary'} className='ms-2 px-2 py-1'>
                {deal.purpose}
            </Badge>
          ) : null}
          <Badge pill color={'info'} className='ms-2 px-2 py-1'>
            Status: {deal.status}
          </Badge>
        </span>
      </Col>
      <Col xs={4} className="text-end">
        <span>Net Projected </span>
        <strong className="fw-bold">
          {currencyFormatter({ isDecimal: false }).format(deal.projectedRevenue) ?? '-'}
        </strong>
        <span> On </span>
        <strong className="fw-bold">{deal.projectedDate ? formatDate(new Date(deal.projectedDate)) : '-'}</strong>
      </Col>
    </Row>
  );
};

export default DealRow;
